import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const ActiveUsers = () => {
    const [chartData, setChartData] = useState({
        series: [{
            name: "Users",
            data: [100, 41, 35, 51, 15, 62, 20]
        }],
        options: {
            chart: {
                type: 'area',
                zoom: {
                    enabled: false
                },
                toolbar: {
                    show: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 1,
                lineCap: 'round'
            },
            grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'],
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            },
            colors: ["#42BA5C"],
            fill: {
                type: 'gradient', // You can also use 'solid' or 'pattern'
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.3,
                    stops: [0, 90, 100]
                }
            }
        }
    });

    return (
        <>
            <div id="chart">
                <ReactApexChart options={chartData.options} series={chartData.series} type="area" height={180} />
            </div>
        </>
    );
}

export default ActiveUsers;
